import axios from "axios";
import {API_ROOT} from "../app/utils";

export function isSyncing(boolean){
	return {
		type: "IS_SYNCING",
		payload: boolean
	}
}

export function isSyncState(){
    return function(dispatch) {

        axios.get(API_ROOT + '/v9/api/sync/state', {withCredentials: true}).then(response => {
            dispatch({
                type: "IS_SYNC_STATE",
                payload: response.data
            });

	        if(response.data === false){
	        	dispatch(isSyncing(false));
	        }

        });
    }
}